import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import './timeSheet.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faFilePen } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Modal } from 'react-bootstrap';
// import dayjs from "dayjs";
function ActivityTimesheet() {
    const navigate = useNavigate();
    const [showReason, setshowReason] = useState(false);
    const handleCloseReason = () => setshowReason(false);
    const handleshowReason = () => setshowReason(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [weekRange, setWeekRange] = useState("");

    const handleDateChange = (date) => {
        setSelectedDate(date);

        if (date) {
        //   const day = date.day(); // 0 (Sunday) to 6 (Saturday)
        const sunday = date.startOf("week"); // Sunday
        const saturday = sunday.add(6, "day"); // Saturday

        const formattedRange = `${sunday.format("DD/MM/YYYY")} to ${saturday.format("DD/MM/YYYY")}`;
        setWeekRange(formattedRange);
        } else {
        setWeekRange("");
        }
    };

  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Timesheet Activity's</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Timesheet Activity's</span>
                </Grid>
                <Grid size={{ xs: 12 }} container justifyContent="flex-end" alignItems="center" className="my-4">
                    <Grid size={{xs: 12 }} container className="gap-3 regiter_inputs i94validateinput">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                        className="date_pickermux date_selectsheet"
                        value={selectedDate}
                        onChange={handleDateChange}
                        renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                    {weekRange && <input style={{width:"max-content"}} value={weekRange} disabled />}
                    </Grid>
                </Grid>
                <Grid size={{xs:12}} container className="mt-4 timesheet_table">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                            <th><input type='checkbox'/></th>
                            <th className='text-start'>Week</th>
                            <th className='text-start'>Status</th>
                            <th>Total Work Hours</th>
                            <th>Over Time Work Hours</th>
                            <th>Report</th>
                            </tr>
                        </thead>
                        <tbody className='tablerow_oddone'>
                            <tr>
                            <td className='text-center'><input type='checkbox'/></td>
                            <td className='text-start'>
                                March 1-7 2024
                            </td>
                            <td>
                                <span className='rejected_timesheet'><FontAwesomeIcon icon={faCircleXmark} /> Rejected</span>
                            </td>
                            <td className='text-start'>40.00</td>
                            <td className='text-start'>40.00</td>
                            <td><button className='timesheet_editbtn' onClick={handleshowReason}><FontAwesomeIcon icon={faFilePen} /></button></td>
                            </tr>
                            <tr>
                            <td className='text-center'><input type='checkbox'/></td>
                            <td className='text-start'>
                                March 1-7 2024
                            </td>
                            <td>
                                <span className='submitted_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Rejected</span>
                            </td>
                            <td className='text-start'>40.00</td>
                            <td className='text-start'>40.00</td>
                            <td><button className='timesheet_editbtn' onClick={handleshowReason}><FontAwesomeIcon icon={faFilePen} /></button></td>
                            </tr>
                            <tr>
                            <td className='text-center'><input type='checkbox'/></td>
                            <td className='text-start'>
                                March 1-7 2024
                            </td>
                            <td>
                                <span className='approved_timesheet'><FontAwesomeIcon icon={faCircleCheck} /> Approved</span>
                            </td>
                            <td className='text-start'>40.00</td>
                            <td className='text-start'>40.00</td>
                            <td><button className='timesheet_editbtn' onClick={handleshowReason}><FontAwesomeIcon icon={faFilePen} /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </Grid>
            <Modal
                show={showReason}
                onHide={handleCloseReason}
                size="lg"
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Body>
                <Grid size={{xs:12}} container>
                    <Grid size={{xs:12}} container flexDirection="column">
                        <h4 className='pink_header_sheet mb-4'>Reason for rejection</h4>
                        <span className='fw-semibold'>Missing Dates/Times:</span>
                        <span className=' mb-3'>Incomplete start/end times, missing lunch breaks.</span>
                        <span className='fw-semibold'>Missing Project/Task Codes:</span>
                        <span className=' mb-3'>No assignment of work to specific projects.</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3">
                        <button className='registersendbtn2 mb-2' onClick={handleCloseReason}>
                            Close
                        </button>
                    </Grid>
                </Grid>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  );
}

export default ActivityTimesheet;